import React, { useState, useEffect } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import "../styles/EmployeeReportFilter.css";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import "react-toastify/dist/ReactToastify.css";

interface FilterProps {
  filtersEmp: {
    fromDate: string;
    toDate: string;
    project: string;
    task: string;
    employeeId: string;
  };
  onFilterChange: (field: string, value: string) => void;
  onFind: () => void;
  onReset: () => void;
}

const EmplyeeReportFilterAdmin: React.FC<FilterProps> = ({
  filtersEmp,
  onFilterChange,
  onFind,
  onReset,
}) => {
  const [localFilters, setLocalFilters] = useState(filtersEmp);
  const projects = useSelector((state: StoreState) => state.project);
  const tasks = useSelector((state: StoreState) => state.task);
  const empreport = useSelector((state: StoreState) => state.employeeReport);

  useEffect(() => {
    setLocalFilters(filtersEmp);
  }, [filtersEmp]);

  const projectOptions = projects.map((p) => ({
    id: p.id.toString(),
    name: p.name,
  }));
  const filteredTasks = tasks.filter(
    (task) =>
      localFilters.project === "" ||
      task.projectId.toString() === localFilters.project,
  );
  const taskOptions = filteredTasks.map((task) => ({
    id: task.id.toString(),
    name: task.title,
  }));
  const filteredReports = empreport.filter(
    (report) =>
      localFilters.task === "" ||
      report.taskId.toString() === localFilters.task,
  );
  const uniqueEmployeeIds = Array.from(
    new Set(filteredReports.map((report) => report.employeeId.toString())),
  ).map((id) => ({
    id,
    name: id.toString(),
  }));

  const handleInputChange = (name: string, value: string) => {
    if (name === "project") {
      setLocalFilters((prev) => ({
        ...prev,
        project: value,
        task: "",
        employeeId: "",
      }));
      onFilterChange("project", value);
      onFilterChange("task", "");
      onFilterChange("employeeId", "");
    } else if (name === "task") {
      setLocalFilters((prev) => ({ ...prev, task: value, employeeId: "" }));
      onFilterChange("task", value);
      onFilterChange("employeeId", "");
    } else if (name === "employeeId") {
      setLocalFilters((prev) => ({ ...prev, employeeId: value }));
      onFilterChange("employeeId", value);
    } else {
      setLocalFilters((prev) => ({ ...prev, [name]: value }));
      onFilterChange(name, value);
    }
  };

  const renderDropdown = (
    label: string,
    name: string,
    value: string,
    options: { id: string; name: string }[],
  ) => (
    <Form.Group
      as={Col}
      xs={6}
      sm={4}
      md={3}
      lg={2}
      className="task-filter-field"
      controlId={name}
    >
      <div className="dropdown-label">{label}</div>
      <Form.Select
        value={value}
        onChange={(e) => handleInputChange(name, e.target.value)}
        className="custom-select"
      >
        <option value="">All</option>
        {options.map((opt) => (
          <option key={opt.id} value={opt.id}>
            {opt.name}
          </option>
        ))}
      </Form.Select>
    </Form.Group>
  );

  const renderDateField = (label: string, name: string, value: string) => (
    <Form.Group
      as={Col}
      xs={6}
      sm={4}
      md={3}
      lg={2}
      className="task-filter-field"
      controlId={name}
    >
      <div className="dropdown-label">{label}</div>
      <Form.Control
        type="date"
        value={value}
        onChange={(e) => handleInputChange(name, e.target.value)}
      />
    </Form.Group>
  );

  return (
    <Form className="task-filter-form">
      <Row className="g-2 align-items-end">
        {renderDateField("From Date", "fromDate", localFilters.fromDate)}
        {renderDateField("To Date", "toDate", localFilters.toDate)}
        {renderDropdown(
          "Project",
          "project",
          localFilters.project,
          projectOptions,
        )}
        {renderDropdown("Task", "task", localFilters.task, taskOptions)}
        {renderDropdown(
          "Employee ID",
          "employeeId",
          localFilters.employeeId,
          uniqueEmployeeIds,
        )}

        <Col className="d-flex justify-content-end align-items-center">
          <Button variant="primary" className="mr-2" onClick={onFind}>
            Find
          </Button>
          <Button variant="secondary" onClick={onReset}>
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default EmplyeeReportFilterAdmin;
